import FilterButton from "../components/shared/FilterButton";

const SelectedMention = () => {
  return (
    <div className="flex flex-col w-full h-full pb-1 overflow-hidden bg-white">
      {/* Header */}
      <div className="w-full h-[22px] border-b border-[#0000002B] flex items-center">
        <h1 className="pl-2 pb-2 text-[13px] font-semibold text-black font-inter">
          Selected Mention
        </h1>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-grow w-full gap-2 overflow-hidden">
        {/* User Info */}
        <div className="flex items-center w-full gap-3 px-2 mt-2">
          <img
            src="/icons/robert.png"
            alt="icon"
            className="w-[40px] h-[40px] object-contain"
          />
          <div className="flex flex-col w-full">
            <div className="flex flex-row items-center gap-1">
              <img
                src="/icons/insta.png"
                alt="icon"
                className="w-[12px] h-[12px] object-contain"
              />
              <span className="text-[12px] font-inter font-semibold text-black">
                James Harrison
              </span>
            </div>
            <span className="text-[12px] font-inter text-[#00000073] text-opacity-80">
              @jamesharrison
            </span>
          </div>
        </div>

        {/* Message */}
        <div className="text-[11px] px-2 font-inter text-[#00000073] text-opacity-80">
          Just got my new headphones from @yourcompany — absolutely blown away
          by the sound quality! #CustomerSatisfaction
        </div>

        {/* Full-height Image */}
        <div className="w-full px-2 overflow-hidden">
          <img
            src="/icons/pc1.png"
            alt="post"
            className="object-cover w-full h-auto rounded"
          />
        </div>

        {/* Actions */}
        <div className="flex flex-row px-2 gap-x-2">
          <div className="flex flex-row items-center">
            <img
              src="/icons/comment.png"
              alt="reply"
              className="w-[15px] cursor-pointer h-[15px] object-contain"
            />
            <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
              Reply
            </span>
          </div>
          <div className="flex flex-row items-center">
            <img
              src="/icons/like.png"
              alt="like"
              className="w-[12px] cursor-pointer h-[12px] object-contain"
            />
            <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
              Like
            </span>
          </div>
        </div>

        {/* Reply Box */}
        <div className="border-t pt-2 border-[#0000002B] px-2">
          <div className="text-[11px] font-inter text-opacity-80 mb-1">
            Reply
          </div>

          {/* Textarea with resize icon */}
          <div className="relative ">
            <textarea
              rows={6}
              placeholder="Thanks for sharing your workspace setup, Alex! It looks fantastic. We're glad our tools are helping with your remote work. Have you tried our new collaboration features yet?"
              className="w-full text-[11px] p-2 border border-[#0000002B] border-opacity-15 rounded-[8px] font-inter text-[#00000073] resize focus:outline-none focus:ring-1 focus:ring-gray-300 "
            />
          </div>
          <div className="flex flex-row items-center justify-end gap-x-1 ">
            <img
              src="/icons/smiley.png"
              alt="like"
              className="w-[15px] cursor-pointer h-[15px] object-contain"
            />{" "}
            <img
              src="/icons/img.png"
              alt="like"
              className="w-[15px] cursor-pointer h-[15px] object-contain"
            />{" "}
            <img
              src="/icons/attach.png"
              alt="like"
              className="w-[15px] cursor-pointer h-[15px] object-contain"
            />
            <button className="px-2 w-auto h-6 text-opacity-90 text-white text-[9px] font-inter font-normal leading-[100%] tracking-[0%] bg-black rounded-[6px] flex items-center justify-center">
              Send Reply
            </button>
          </div>
        </div>
        <div className="flex flex-row border-t border-[#0000002B] justify-between">
          <FilterButton
            label="Tags"
            icon="/icons/akar.png"
            className="mt-2 ml-2"
            onClick={() => "Tags Filter Clicked"}
          />
          <FilterButton
            label="Flag"
            icon="/icons/flag.png"
            className="mt-2 ml-2"
            onClick={() => "Tags Filter Clicked"}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectedMention;
